<app-header></app-header>
<app-sidebar></app-sidebar>
<link href="https://cdn.jsdelivr.net/gh/gitbrent/bootstrap4-toggle@3.6.1/css/bootstrap4-toggle.min.css" rel="stylesheet">
<script src="https://cdn.jsdelivr.net/gh/gitbrent/bootstrap4-toggle@3.6.1/js/bootstrap4-toggle.min.js"></script>
<div class="content-wrapper">
    <div class="row">
        <div class="col-md-12">

            <div class="card">
                <div class="card-header">เปิดปิดการแจ้งคิวแบบไม่มีการตกรอบ ตกคิว </div>
                <div class="card-body">
                    <div class="form-group">
                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">

                            <p *ngFor="let item of getqueue">สถานนะตอนนี้ !!
                                <label *ngIf="item.chk_looplost =='N'" >เปิด</label>
                                <label *ngIf="item.chk_looplost !='N'" >ปิด</label>
                            </p>

                            <button class="btn btn-danger" (click)="SwithQueu(2);">ปิด</button>  &nbsp; &nbsp;
                            <button class="btn btn-success" (click)="SwithQueu(3);">เปิด</button>

                        </div>
                      </div>
                      <hr/>
                </div>

                <div class="card-header">เปิดปิดการใช้คิวเสรี </div>
                <div class="card-body">
                    <div class="form-group">
                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">

                            <p *ngFor="let item of getqueue">สถานนะตอนนี้ !!
                                <label *ngIf="item.qfree =='Y'" >เปิด</label>
                                <label *ngIf="item.qfree =='N'" >ปิด</label>
                            </p>

                            <button class="btn btn-danger" (click)="SwithQfree(0);">ปิด</button>  &nbsp; &nbsp;
                            <button class="btn btn-success" (click)="SwithQfree(1);">เปิด</button>

                        </div>
                      </div>
                      <hr/>
                </div>
                
            </div>
        </div>
    </div>
  
    
</div>
<app-footer></app-footer>